module.exports = __webpack_public_path__ + "img/alhcd-zpr55.7e0ceb65.png";